import styled from 'styled-components';
import { ButtonContainer } from '../Button';

const HORIZ_GUTTER = 24;
const VERT_GUTTER = 60;

export const StyledCardsList = styled.div`
  ${({ theme }) => theme.custom.helpers.LayoutContainer``};

  > div {
    padding-bottom: ${VERT_GUTTER}px;
  }
`;

export const StyledCardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  width: calc(100% + ${HORIZ_GUTTER}px);
  margin: ${HORIZ_GUTTER * -0.5}px;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    margin: ${VERT_GUTTER * -0.5}px ${HORIZ_GUTTER * -0.5}px;
    justify-content: flex-start;
  }
`;

export const StyledCardItem = styled.div`
  padding: ${HORIZ_GUTTER * 0.5}px;
  width: calc(100% / 1);
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    padding: ${VERT_GUTTER * 0.5}px ${HORIZ_GUTTER * 0.5}px;
    width: calc(100% / 2);
  }
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    width: calc(100% / 3);
  }
`;

export const StyledLoadMore = styled(ButtonContainer)`
  padding-bottom: 40px;
  padding-top: 40px;
`;

export const StyledErrorMessage = styled.div`
  ${({ theme }) => theme.custom.helpers.LayoutContainer``};
  > div {
    margin-top: 40px;
    text-align: center;
  }
`;
